import React, { useState } from 'react';
import { signIn } from '../services/auth';
import { Button, ErrorText, errorMessage } from '../components/ui';
import logo from '@assets/ydyai-logo.png';

export default function LoginPage() {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSignIn() {
    setBusy(true);
    setError('');
    try {
      await signIn();
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  }

  return (
    <div className="center-screen">
      <div className="card" style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <img className="logo" src={logo} alt="your data your ai" style={{ margin: '0 auto 4px' }} />
        <p className="sub">Sign in with your work account to continue.</p>
        <ErrorText>{error}</ErrorText>
        <Button block onClick={handleSignIn} disabled={busy}>
          {busy ? 'Redirecting…' : 'Sign in with Microsoft'}
        </Button>
      </div>
    </div>
  );
}
